export enum HighLightType {
    None,
    Selected,
    Error
};